import $ from "jquery";

export default function () {
    let openMenu = document.getElementById("open-menu");
    let closeMenu = document.getElementById("close-menu");
    let menu = document.getElementById("full-screen-menu");
    let $subMenu = $(".header__submenu");
    let $subMenuButton = $(".header__open-submenu");
    let $subMenuWrapper = $("#sub-menu-wrapper");

    openMenu.addEventListener("click", () => {
        menu.style.display = "flex";
    });

    closeMenu.addEventListener("click", () => {
        menu.style.display = "none";
        $(".header__main-wrapper").show()
        // $subMenuWrapper.html("")
    });

    $('.js-menu-forward').on('click', function () {
        $(this).closest('.js-menu--inner').addClass('hidden');
        $(this).closest('.js-top-menu').addClass('hidden');
        $(this).parent().next('.js-menu--inner').addClass('isOpen');
    })

    // menu back
    $('.js-menu-back').on('click', function () {
        const parentMenu = $(this).closest('.js-menu--inner');
        parentMenu.removeClass('isOpen');

        const parentsParent = parentMenu.closest('ul.menu__options').closest('.js-menu--inner')
        if (parentsParent.length) {
            parentsParent.removeClass('hidden');
        } else {
            $(this).closest('.js-top-menu').removeClass('hidden');
        }
    })

    // handle opening of submenu
    // $subMenuButton.on("click", function () {
    //     // find the relevant menu item ref
    //     let targetRef = $(this).closest("li").data('ref');
    //     // find the relevant submenu
    //     let $target = $('.header__submenu[data-menu="' + targetRef + '"]')
    //
    //     // $target.addClass('isOpen');
    //     // $subMenuWrapper.innerHTML = ""
    //      const getSubMenu = $(".ul-test")
    //
    //      console.log(getSubMenu)
    //
    //      const clonedSubMenu = getSubMenu.clone(true)
    //
    //     //  console.log($subMenuWrapper)
    //     //  console.log(clonedSubMenu)
    //
    //      $subMenuWrapper.append(clonedSubMenu)
    //
    //      $(".header__main-wrapper").hide()
    //
    // });
    $('.hero-home__svg').on('click', function () {
        $('#content-body')[0].scrollIntoView()
    })
}
